var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActivestep3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.235 11.408h.95c.598-.009 1.067-.166 1.409-.471.341-.306.512-.718.512-1.238 0-1.166-.58-1.75-1.743-1.75-.547 0-.984.157-1.312.472-.324.31-.486.722-.486 1.237H9.301c0-.788.287-1.442.861-1.962.579-.524 1.313-.786 2.201-.786.94 0 1.675.249 2.208.745.534.497.8 1.187.8 2.072 0 .432-.141.852-.424 1.257a2.518 2.518 0 01-1.141.91c.546.173.968.46 1.264.86.301.402.451.892.451 1.47 0 .894-.291 1.602-.875 2.127-.583.524-1.342.786-2.276.786-.934 0-1.695-.253-2.283-.76-.583-.505-.875-1.173-.875-2.002h1.271c0 .524.171.943.513 1.258.342.314.8.472 1.374.472.61 0 1.078-.16 1.402-.479.323-.319.485-.777.485-1.374 0-.579-.178-1.023-.533-1.333-.356-.31-.869-.47-1.539-.479h-.95v-1.032z",
    fill: "#fff"
  })));
}
SvgActivestep3.displayName = 'Activestep3';
export default SvgActivestep3;